let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lcIe7")).then(() => parcelRequire('lumIR'));